import {Component, OnInit} from '@angular/core';

import {AlertService, AuthenticationService, ProjectService} from '../../_services/index';

import {ActivatedRoute, Router} from '@angular/router';

import {User} from '../../_models/index';
import {LoginHelper} from '../../helpers';
import {AssessmentNote} from "../../_models/assessmentNote";
import * as moment from "moment";

@Component({
    standalone: false,
  selector: "assessmentFindings-component",
  templateUrl: 'assessmentFindings.component.html',
  styleUrls: ['./assessmentFindings.component.scss'],
})

export class AssessmentFindingsComponent implements OnInit {
  assessmentNotes: AssessmentNote[] = [];
  allAssessmentNotes: AssessmentNote[] = [];
  currentUser: User;
  projectId: number;
  currentYear: number;
  rowGroupMetadata: any = {};
  fromDate = '';
  toDate = '';
  assessmentResults = {0: 'Satisfactory', 1: 'Deficiency', 2: 'Pending'}
  cols: any[] = [
    { 'field': 'complianceAreaControlId', 'header': 'Control ID' },
    {'field': 'label', 'header': 'ID', width: '8em'},
    { 'field': 'nameTitle', 'header': 'Name' },
    {'field': 'assessmentResultsText', 'header': 'Assessment Results'},
    {'field': 'finding', 'header': 'Finding', width: '25%'},
  ]

  constructor(
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {

    this.projectId = route.snapshot.params['projectId'];
    this.currentYear = new Date(Date.now()).getFullYear();
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.loadProjectControlItems();
  }

  public loadProjectControlItems() {
    const year = new Date(Date.now()).getFullYear();
    this.projectService.getById(this.projectId)
      .subscribe(project => {
          const projectControlItems = project.projectControlItems.filter(x => x.assessmentNotes != null && x.assessmentNotes.length > 0);

          const index = 1;
          const assessmentNotes = [];
          const actionPlans = [];
          projectControlItems.forEach(projectControlItem => {
            projectControlItem.actionPlans.forEach(p => actionPlans.push(p));
          });
          projectControlItems.forEach(projectControlItem => {
            projectControlItem.assessmentNotes.filter(i => i.isVisible && !i.isThirdParty).sort((a, b) => a.actionPlanId > b.actionPlanId ? 1 : -1).forEach(assessmentNote => {
              assessmentNote.label = `A${assessmentNote.assessmentNoteId}`
              assessmentNote.complianceAreaControlId = projectControlItem.controlItem.complianceAreaControlId;
              assessmentNote.category = projectControlItem.controlItem.category;
              assessmentNote.actionPlans = actionPlans.filter(p => (',' + p.assessmentNoteIds + ',').indexOf(',' + assessmentNote.assessmentNoteId + ',') >= 0);
              assessmentNote.actionPlansText = assessmentNote.actionPlans.map(p => p.weaknessDescription).join(', ');
              assessmentNote.assessmentResultsText = this.assessmentResults[assessmentNote.assessmentResults];
              assessmentNote.nameTitle = assessmentNote.name + (assessmentNote.title ? (', ' + assessmentNote.title) : '');
              assessmentNotes.push(assessmentNote);
            });
          });

          this.allAssessmentNotes = this.assessmentNotes = assessmentNotes;

          this.updateRowGroupMetaData();
        },

        error => {
          const errorMessage = 'An error occurred while loading projects.';
          this.alertService.error(errorMessage);
        });
  }


  updateRowGroupMetaData() {
    if (this.assessmentNotes) {
      for (let i = 0; i < this.assessmentNotes.length; i++) {
        let rowData = this.assessmentNotes[i];
        let brand = rowData.complianceAreaControlId;
        if (i == 0) {
          this.rowGroupMetadata[brand] = {index: 0, size: 1};
        } else {
          let previousRowData = this.assessmentNotes[i - 1];
          let previousRowGroup = previousRowData.complianceAreaControlId;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = {index: i, size: 1};
        }
      }
    }
  }

  filter() {
    const from = this.fromDate ? moment(this.fromDate) : null;
    const to = this.toDate ? moment(this.toDate) : null;
    this.assessmentNotes =this.allAssessmentNotes.filter(a => (!from || moment(a.date).isSameOrAfter(from)) && (!to || moment(a.date).isSameOrBefore((to))));
  }

}
